export default "__VITE_ASSET__BVFsdEdt__"